import {
    SUPPLIER_LIST,
    SUPPLIER_LIST_SUCCESS,
    SUPPLIER_LIST_ERROR,
    ADD_FORM,
    ADD_FORM_SUCCESS,
    ADD_FORM_ERROR,
    FORM_UPLOAD_SET,
    FORM_UPLOAD_SET_SUCCESS,
    FORM_UPLOAD_SET_ERROR,
    FORM_UPLOAD_RESET
} from '../actions';

const INIT_STATE = {
    loading: true,
    init: true,
    supplier: {
        data: [],
        loading: true,
    },
    add: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    error: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SUPPLIER_LIST:
            return {
                ...state,
                loading: true,
                supplier: {
                    ...state.supplier
                }
            }
        case SUPPLIER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                supplier: {
                    ...state.supplier,
                    ...action.payload
                }
            }
        case SUPPLIER_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case ADD_FORM:
            return {
                ...state,
                loading: true,
                add: {
                    ...state.add
                }
            }
        case ADD_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                add: {
                    ...state.add,
                    ...action.payload,
                    id_status:1
                    
                }
            }
        case ADD_FORM_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case FORM_UPLOAD_SET:
            return { ...state };
        case FORM_UPLOAD_SET_SUCCESS:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };
        case FORM_UPLOAD_SET_ERROR:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };
        case FORM_UPLOAD_RESET:
            return {
                ...state,
                file: []
            };
       
        default:
            return { ...state };
    }

};